export default __webpack_public_path__ + "fe01c008be032014dc3be7732f5578b0.svg";